var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 87,
    viewBox: "0 0 118 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231361 79.3613C-0.121435 79.7862 -0.062974 80.4166 0.361942 80.7694L7.28634 86.5186C7.71125 86.8714 8.34171 86.8129 8.69451 86.388C9.0473 85.9631 8.98884 85.3326 8.56393 84.9798L2.40891 79.8695L7.51927 73.7145C7.87207 73.2895 7.81361 72.6591 7.38869 72.3063C6.96377 71.9535 6.33331 72.012 5.98051 72.4369L0.231361 79.3613ZM116.013 0.843492C111.387 30.0271 101.503 47.7 83.5024 59.0236C65.399 70.4118 38.951 75.4766 0.908404 79.0043L1.09307 80.9958C39.1143 77.47 66.0133 72.3882 84.5674 60.7165C103.224 48.9803 113.308 30.6799 117.988 1.15662L116.013 0.843492Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow4);
export default __webpack_public_path__ + "static/media/Arrow4.83a2fe57f85d72c0e106855824e48cd0.svg";
export { ForwardRef as ReactComponent };